import { Base } from "../../../../core/db/models/index";
import { OrderItemLike } from "./orderItem";
import { CleansingType } from "./index";
import { WithAllType, arrayOrCollection } from "../../../../core/db/index";
import FortumDatabase from "../../index";
import { MeasurementLike } from "./measurement";
import { OfflineMixin } from "./order";

export interface CleansingInstanceLike extends Base, OfflineMixin
{
    item_id: number;
    item?: OrderItemLike;
    usages?: CleansingTypeUsageLike[];
    measurements?: MeasurementLike[];
}

export class CleansingInstance implements Partial<CleansingInstanceLike>
{
    public static withAll(db: FortumDatabase, input: WithAllType<CleansingInstanceLike>): PromiseLike<CleansingInstanceLike[]>
    {
        let objects: CleansingInstanceLike[];

        return arrayOrCollection(input).then((resolved) =>
        {
            objects = resolved;
                
            let objectIds = objects.map(o => o.id);
            return Promise.all([
                db.DeconCleansingTypeUsage.where('instance_id').anyOf(objectIds).toArray(),
            ]);
        }).then((results) =>
        {
            let usages: CleansingTypeUsageLike[] = results[0];

            for(let object of objects)
            {
                object.usages = usages.filter(o => o.instance_id == object.id);
            }
            
            return DeconCleansingTypeUsage.withAll(db, usages);
        }).then(() =>
        {
            return objects;
        });
    }
}   

export interface CleansingTypeUsageLike extends Base, OfflineMixin
{
    instance_id: number;
    type_id: number;

    instance?: CleansingInstanceLike;
    type?: CleansingType;
}

export default class DeconCleansingTypeUsage implements Partial<CleansingTypeUsageLike>
{
    public static withAll(db: FortumDatabase, targetCleansingTypeUsages: WithAllType<CleansingTypeUsageLike>): PromiseLike<CleansingTypeUsageLike[]>
    {
        let cleansingTypeUsages: CleansingTypeUsageLike[];

        return arrayOrCollection(targetCleansingTypeUsages).then((resolvedCleansingTypeUsages) =>
        {
            cleansingTypeUsages = resolvedCleansingTypeUsages;
            let promises: PromiseLike<any>[] = [];

            promises.push(db.DeconCleansingType.where('id').anyOf(cleansingTypeUsages.map(o => o.type_id)).toArray());

            return Promise.all(promises);
        }).then((results) =>
        {
            let types: CleansingType[] = results[0];

            for(let usage of cleansingTypeUsages)
            {
                usage.type = types.find(o => o.id == usage.type_id);
            }

            return cleansingTypeUsages;
        });
    }
}